import { Injectable } from '@angular/core';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CellularDeviceCommunicationHardwareService {
    public static $name: string = 'cellularDeviceCommunicationHardwareService';

    private _communicationHardware: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceCommunicationHardwareViewModel[];

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getCommunicationHardware():
        Promise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceCommunicationHardwareViewModel[]> {
        if (this._communicationHardware) {
            return Promise.resolve(this._communicationHardware);
        } else {
            return this.initialize();
        }
    }

    private initialize(): Promise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceCommunicationHardwareViewModel[]> {
        return this.proxyService.request({
            endPoint: 'cellularDeviceCommunicationHardware',
            route: 'getCellularDeviceCommunicationHardware'
        }).asArray<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceCommunicationHardwareViewModel>().then(result => {
            this._communicationHardware = result;
            return result;
        }) as Promise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceCommunicationHardwareViewModel[]>;
    }
}
